<template>
  <div class="content-header_mobile" v-if="0">
    <div class="content-header_mobile__logo">
      <img src="@/assets/img/logo_mobile.png" alt="logo"/>
    </div>
<!--    <div class="content-header_mobile__btn">-->
<!--      <button @click="isMenuActive = !isMenuActive"><i class="fas fa-bars"></i><span>МЕНЮ</span></button>-->
<!--    </div>-->
<!--    <RouterLink :to="{name: 'notifications'}" class="content-header_mobile__notification" v-if="user">-->
<!--      <i class="far fa-bell"></i>-->
<!--      <span class="content-header_mobile__notification-count" v-if="newNotificationsCount">{{ newNotificationsCount }}</span>-->
<!--    </RouterLink>-->
<!--    <RouterLink :to="{name: 'user'}" class="content-header_mobile__avatar" v-if="user">-->
<!--      <img :src="user?.avatar_url" alt="аватар" v-if="user?.avatar_url">-->
<!--      <img src="@/assets/img/user.png" alt="нет аватара" v-else>-->
<!--    </RouterLink>-->
  </div>

  <div class="mobile_menu" :class="{open: isMenuActive}" @click.stop>
    <button class="content-header__close" @click.prevent="isMenuActive = !isMenuActive">
      <i class="fas fa-times"></i>
    </button>
    <div class="mobile_menu__header">
      <RouterLink v-if="user && content.tickets" :to="{name: 'practice-batches'}">
        Оплаченные пакетные занятия
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <RouterLink v-if="practicesForReview.length" :to="{name: 'practices-review'}">
        Оцените преподавателя <span class="item-menu__circle">{{ practicesForReview.length }}</span>
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <RouterLink v-if="user" :to="{name: 'general-testing'}">
        Тест ГИМС
        <i class="fas fa-chevron-right"></i>
      </RouterLink>

      <RouterLink :to="{name: 'setup'}">
        {{ user ? 'Записаться на теорию' : 'Записаться на обучение' }}
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <RouterLink :to="{name: user ? 'setup-practice' : 'general-testing-access'}">
        {{ user ? 'Записаться на практику' : 'Тест ГИМС' }}
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <!-- <RouterLink :to="{name: 'practice-exam'}">
        Практический экзамен
        <i class="fas fa-chevron-right"></i>
      </RouterLink> -->
      <RouterLink :to="{name: 'master-class'}">
        Записаться на мастер-класс
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <RouterLink v-if="content?.tickets" :to="{name: 'tickets'}">
        Библиотека судоводителя
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <RouterLink v-if="0" :to="{name: 'teams'}">
        Наша команда
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <RouterLink v-if="0" :to="{name: 'fleet'}">
        Наш флот
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
    </div>
    <div class="mobile_menu__footer">
      <RouterLink :to="{name: 'legal'}" class="item-menu">
        Правовые документы
        <i class="fas fa-chevron-right"></i>
      </RouterLink>
      <a href="#" v-if="user" @click.prevent="close() ^ $emit('showSupport')">
        Поддержка
        <i class="fas fa-chevron-right"></i>
      </a>
      <a href="https://sea-law.ru/kontakty.html" target="_blank">
        Адрес и контакты
        <i class="fas fa-external-link-alt"></i>
      </a>
      <a href="https://sea-law.ru/" target="_blank">
        Основной сайт
        <i class="fas fa-external-link-alt"></i>
      </a>
    </div>
  </div>

  <div class="footer-menu">
    <template v-if="user">
      <RouterLink :to="{name: 'timetable'}" class="footer-menu-item">
        <i class="fas fa-book-open"></i>
        <span>Расписание</span>
      </RouterLink>
      <RouterLink :to="{name: 'notifications'}" class="footer-menu-item">
        <i class="far fa-bell">
          <span class="content-header_mobile__notification-count" v-if="newNotificationsCount">{{ newNotificationsCount }}</span>
        </i>
        <span>Уведомления</span>
      </RouterLink>
      <RouterLink :to="{name: 'user'}" class="footer-menu-item">
        <i class="fas fa-user"></i>
        <span>Профиль</span>
      </RouterLink>
    </template>
    <template v-if="!user">
      <RouterLink :to="{name: 'setup'}" class="footer-menu-item">
        <i class="fas fa-briefcase"></i>
        <span>Записаться на обучение</span>
      </RouterLink>
      <RouterLink :to="{name: 'general-testing-access'}" class="footer-menu-item">
        <i class="fas fa-tasks"></i>
        <span>Тест ГИМС</span>
      </RouterLink>
      <RouterLink :to="{name: 'auth'}" class="footer-menu-item">
        <i class="fas fa-user"></i>
        <span>Войти / Зарегистрироваться</span>
      </RouterLink>
    </template>
    <button @click="isMenuActive = !isMenuActive" class="footer-menu-item">
      <i class="fas fa-bars"></i>
      <span>Меню</span>
    </button>
  </div>
</template>

<script>
import {inject, onMounted, ref} from "@vue/runtime-core";
import {useRouter} from "vue-router";
import {getPracticesForReviews} from "@/data/requests";

export default {
  emits: ['showSupport'],
  setup() {
    const user = inject('user');
    const logout = inject('logout')
    const isMenuActive = ref(false);
    const content = inject('siteInfo');
    const token = inject('token');
    const newNotificationsCount = inject('new-notifications-count');

    function close() {
      isMenuActive.value = false;
    }

    const router = useRouter();
    router.beforeResolve(close);

    const practicesForReview = ref([1,2,3])

    onMounted(async () => {
      practicesForReview.value = await getPracticesForReviews(token.value)
    })

    return {isMenuActive, close, user, logout, content, newNotificationsCount, practicesForReview};
  }
}
</script>
<style scoped>
.content-header_mobile__notification {
  position: relative;
}
.content-header_mobile__notification-count {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #da482e;
  font-size: 10px;
  width: 15px;
  height: 15px;
  line-height: 15px;
  color: white;
  text-align: center;
  border-radius: 50%;
}
.content-header_mobile__logo {
  margin-left: 10px;
}
.content-header_mobile__btn button {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 9px;
  font-weight: bold;
}
.item-menu__circle {
  background-color: #da482e;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  color: white;
  font-size: 10px;
  margin-left: 3px;
  padding: 0;
  vertical-align: middle;
}
.footer-menu {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  display: none;
  justify-content: space-between;
  padding: 10px 40px;
  gap: 5px;
  z-index: 99;
  box-shadow: 0 0 9px -2px #000;
}
.footer-menu-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  color: #737d82;
  text-decoration: none;
  font-size: 10px;
  text-align: center;
}
.footer-menu-item i {
  font-size: 24px;
  position: relative;
}

@media all and (max-width: 1025px) {
  .footer-menu {
    display: flex;
  }
}
.mobile_menu {
  padding: 50px 20px 50px 20px;
  overflow-y: auto;
  box-sizing: border-box;
}
.mobile_menu .content-header__close {
  width: 40px;
  height: 39px;
  position: absolute;
  top: 10px;
  right: 10px;
}
.mobile_menu__footer,
.mobile_menu__header {
  gap: 10px;
}
.mobile_menu__header a,
.mobile_menu__footer a {
  text-align: left;
}
.mobile_menu a {
  position: relative;
}
.mobile_menu a i {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
}
</style>

